import { render, staticRenderFns } from "./QuoteSummaries.vue?vue&type=template&id=68699dee"
import script from "./QuoteSummaries.vue?vue&type=script&lang=js"
export * from "./QuoteSummaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports